import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaCalendarAlt, FaSearch, FaStore, FaUser, FaFileExcel } from "react-icons/fa";
import { BsGraphUpArrow } from "react-icons/bs";
import { Line } from "react-chartjs-2";
import { Bar } from "react-chartjs-2";
import "./SalesReportPrint.css";
import jsPDF from "jspdf";
import { useRef } from "react";
import html2canvas from "html2canvas";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import { format } from "date-fns";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Tooltip, Legend);

const SalesReport = () => {
  const [summary, setSummary] = useState(null);
  const [chartData, setChartData] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [cashiers, setCashiers] = useState([]);
  const [outlets, setOutlets] = useState([]);
  const printRef = useRef();
  const role = localStorage.getItem("role");
  const idOutletManager = localStorage.getItem("id_outlet");
  const [printMode, setPrintMode] = useState(null); // null | 'grafik' | 'transaksi'
  const [filters, setFilters] = useState({
    
    start_date: "",
    end_date: "",
    cashier: "",
    outlet: "",
    // category: "",
    name: "",
  });
  const [tempFilters, setTempFilters] = useState(filters);
  const [salesPerDay, setSalesPerDay] = useState([]);
  const [chartFilter, setChartFilter] = useState({
    outlet_id: "",
    start_date: "",
    end_date: "",
  });

  const token = localStorage.getItem("token");
const [monthlyTransactions, setMonthlyTransactions] = useState([]);
const [monthlyMeta, setMonthlyMeta] = useState(null);
const [monthlyPage, setMonthlyPage] = useState(1);
const [monthlyFilters, setMonthlyFilters] = useState({
  outlet_id: "",
  search: "",
  order_by: "date",
  sort: "DESC",
});

const [firstClickDate, setFirstClickDate] = useState(null);
const [shiftOptions, setShiftOptions] = useState([]);
const [dateRange, setDateRange] = useState([null, null]);
const [selectedShift, setSelectedShift] = useState("1");
const [customStartTime, setCustomStartTime] = useState("08:00:00");
const [customEndTime, setCustomEndTime] = useState("17:00:00");
const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

const startDate = dateRange[0];
const endDate = dateRange[1];
const [salesPerCashier, setSalesPerCashier] = useState([]);
const [selectedCashierId, setSelectedCashierId] = useState("");
const [selectedCashierDate, setSelectedCashierDate] = useState("");
// Fetch shifts from API (skip "Libur")
useEffect(() => {
  const fetchShifts = async () => {
   const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/shift`, {
  headers: { Authorization: `Bearer ${token}` },
    });
    const validShifts = res.data.data.filter((s) => s.code !== "L");
    setShiftOptions(validShifts);

  };
  fetchShifts();
}, []);
useEffect(() => {
  if (printMode === "grafik" || printMode === "transaksi") {
    // Delay untuk memastikan render selesai
    const timeout = setTimeout(() => {
      window.print();
    }, 600); // aman 600ms

    return () => clearTimeout(timeout);
  }
}, [printMode]);

  useEffect(() => {
    fetchCashiers();
    fetchOutlets();
  }, []);

  useEffect(() => {
  if (filters.start_date && filters.end_date) {
    fetchSalesReport();
  }
}, [filters]);
const exportTransactionsToExcel = async () => {
  try {
    let allData = [];
    let currentPage = 1;
    let totalPages = 1;

    // Loop ambil semua halaman
    do {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/report/sales-report-per-month`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          outlet_id: monthlyFilters.outlet_id,
          search: monthlyFilters.search,
          order: monthlyFilters.order_by,
          sort: monthlyFilters.sort,
          per_page: 10, // sesuai limit API
          page: currentPage
        }
      });

      allData = [...allData, ...res.data.data];
      totalPages = res.data.meta.last_page;
      currentPage++;
    } while (currentPage <= totalPages);

    // Konversi ke format Excel
    const worksheetData = allData.map((item) => ({
      Tanggal: new Date(item.date).toLocaleDateString("id-ID"),
      Kode: item.code,
      Status: item.status,
      Jenis: item.type,
      Jumlah: item.amount,
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Transaksi Bulanan");

    const outletName = monthlyFilters.outlet_id
      ? outlets.find(o => o.value === monthlyFilters.outlet_id)?.label || "Semua_Outlet"
      : "Semua_Outlet";

    const bulanTahun = allData.length > 0
      ? new Date(allData[0].date).toLocaleDateString("id-ID", { month: "long", year: "numeric" })
      : "Semua_Waktu";

    const searchText = monthlyFilters.search
      ? `_Cari_${monthlyFilters.search.replace(/\s+/g, "_")}`
      : "";

    const fileName = `Laporan_Transaksi_Bulanan_${outletName}_${bulanTahun}${searchText}.xlsx`;

    XLSX.writeFile(workbook, fileName);
    // alert(`Export selesai, total data: ${allData.length}`);
  } catch (err) {
    console.error("Gagal export semua data:", err);
    alert("Terjadi kesalahan saat export data.");
  }
};

const exportChartAndDataToExcel = async () => {
  const chartCanvas = document.getElementById("weeklyChart");
  if (!chartCanvas) {
    alert("Chart tidak ditemukan");
    return;
  }

  // Ambil data URI gambar chart
  const chartImage = chartCanvas.toDataURL("image/png");

  // Buat workbook Excel
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Grafik Mingguan");

  // Tambah gambar ke workbook
  const imageId = workbook.addImage({
    base64: chartImage,
    extension: "png",
  });

  // Tempatkan gambar di cell B2 sampai H20
  worksheet.addImage(imageId, {
    tl: { col: 1, row: 1 },
    ext: { width: 500, height: 300 },
  });

  // Tambahkan data tabel di bawah chart
  worksheet.addRow([]);
  worksheet.addRow(["Hari", "Penjualan Minggu Ini", "Penjualan Minggu Lalu"]);

  chartData.forEach((item) => {
    worksheet.addRow([item.day, item.this_week, item.last_week]);
  });

  // Nama file mengikuti filter
  const outletName = filters.outlet
    ? outlets.find(o => o.value === filters.outlet)?.label || "Semua_Outlet"
    : "Semua_Outlet";

  const startDate = filters.start_date || "Semua_Tanggal";
  const endDate = filters.end_date || startDate;

  const fileName = `Grafik_Mingguan_${outletName}_${startDate}_${endDate}.xlsx`;

  // Export sebagai file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/octet-stream" });
  saveAs(blob, fileName);
};


const exportSalesPerDayToExcel = async () => {
  const chartCanvas = document.querySelector("#salesPerDayChart canvas");
  if (!chartCanvas) {
    alert("Grafik Penjualan per Hari tidak ditemukan");
    return;
  }

  const chartImage = chartCanvas.toDataURL("image/png");
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Penjualan Per Hari");

  // Masukkan gambar grafik
  const imageId = workbook.addImage({
    base64: chartImage,
    extension: "png",
  });
  worksheet.addImage(imageId, {
    tl: { col: 1, row: 1 },
    ext: { width: 500, height: 300 },
  });

  // Tambahkan tabel data
  worksheet.addRow([]);
  worksheet.addRow(["No", "Nama Kasir", "Total Penjualan"]);
  salesPerDay.forEach((item, idx) => {
    worksheet.addRow([idx + 1, item.fullname, item.total_amount]);
  });

  // Nama file mengikuti filter
  const outletName = chartFilter.outlet_id
    ? outlets.find(o => o.value === chartFilter.outlet_id)?.label || "Semua_Outlet"
    : "Semua_Outlet";
  const startDate = chartFilter.start_date
    ? chartFilter.start_date.split("T")[0]
    : "Semua_Tanggal";
  const endDate = chartFilter.end_date
    ? chartFilter.end_date.split("T")[0]
    : startDate;

  const fileName = `Grafik_Penjualan_Per_Hari_${outletName}_${startDate}_${endDate}.xlsx`;

  // Simpan file
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer], { type: "application/octet-stream" }), fileName);
};

const exportSalesPerCashierToExcel = async () => {
  const chartCanvas = document.querySelector("#salesPerCashierChart canvas");
  if (!chartCanvas) {
    alert("Grafik Penjualan per Jam tidak ditemukan");
    return;
  }

  const chartImage = chartCanvas.toDataURL("image/png");
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Penjualan Per Jam");

  // Masukkan gambar grafik
  const imageId = workbook.addImage({
    base64: chartImage,
    extension: "png",
  });
  worksheet.addImage(imageId, {
    tl: { col: 1, row: 1 },
    ext: { width: 500, height: 300 },
  });

  // Tambahkan tabel data
  worksheet.addRow([]);
  worksheet.addRow(["No", "Jam", "Jumlah Penjualan"]);
  salesPerCashier.forEach((item, idx) => {
    worksheet.addRow([idx + 1, item.hour, item.amount]);
  });

  // Nama file mengikuti filter
  const outletName = tempFilters.outlet
    ? outlets.find(o => o.value === tempFilters.outlet)?.label || "Semua_Outlet"
    : "Semua_Outlet";
  const date = selectedCashierDate || "Semua_Tanggal";
  const cashierName = selectedCashierId
    ? cashiers.find(c => c.value === selectedCashierId)?.label || "Semua_Kasir"
    : "Semua_Kasir";

  const fileName = `Grafik_Penjualan_Per_Jam_${cashierName}_${outletName}_${date}.xlsx`;

  // Simpan file
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer], { type: "application/octet-stream" }), fileName);
};


  
const handlePrintKasir = () => {
  if (salesPerDay.length === 0) {
    alert("Data belum tersedia untuk dicetak.");
    return;
  }


  setTimeout(() => {
    window.print();
  }, 500);
};

 const fetchCashiers = async (outletIdFromSelect = null) => {
  try {
    const role = localStorage.getItem("role");
    let outletId = outletIdFromSelect;

    // Jika manager, ambil dari localStorage
    if (role === "manager") {
      outletId = localStorage.getItem("id_outlet");
    }

    if (!outletId) return; // jangan fetch jika outlet belum dipilih

    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/employee`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        role: "",
        id_outlet: outletId,
      },
    });

    setCashiers(res.data.data.map(emp => ({ value: String(emp.id), label: emp.full_name })));
  } catch (err) {
    console.error("Failed to fetch cashiers", err);
  }
};


  const fetchOutlets = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/outlet`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOutlets(res.data.data.map(outlet => ({
        value: String(outlet.id),
        label: outlet.name,
      })));
    } catch (err) {
      console.error("Failed to fetch outlets", err);
    }
  };

  const fetchSalesReport = async (customFilters = filters) => {
  try {
    const params = {
      page: 1,
      per_page: 1,
      order_by: "t.created_at",
      sort: "DESC",
    };

    if (customFilters.start_date) params.start_date = customFilters.start_date;
    if (customFilters.end_date) params.end_date = customFilters.end_date;
    if (customFilters.outlet) params.outlet = customFilters.outlet;
    if (customFilters.cashier) params.cashier = customFilters.cashier;
    if (customFilters.name) params.name = customFilters.name;

    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/report/sales-report`, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });

    const data = res.data.data;
    setSummary(data.summary);
    setChartData(data.chart);
    setTransactions(data.transactions);
  } catch (err) {
    console.error("Failed to fetch sales report", err);
  }
};


  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setTempFilters(prev => ({ ...prev, [name]: value }));
  };

const handleApplyFilter = () => {
  setFilters(tempFilters);
  fetchSalesReport(tempFilters); // Tambahkan ini untuk langsung refresh grafik
};


  const handleExportPDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const content = document.getElementById("report-content");
    if (!content) return;

    const canvas = await html2canvas(content);
    const imgData = canvas.toDataURL("image/png");

    const outletObj = outlets.find(o => o.value === filters.outlet);
    const outletName = outletObj ? outletObj.label : "Semua Outlet";
    const startDate = filters.start_date || "Semua";
    const endDate = filters.end_date || "Semua";
    const filename = `sales-report(${outletName})-${startDate}-${endDate}.pdf`;

    const imgProps = doc.getImageProperties(imgData);
    const pdfWidth = doc.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    doc.text("Sales Report", pdfWidth / 2, 10, { align: "center" });
    doc.text(`Outlet: ${outletName}`, pdfWidth / 2, 17, { align: "center" });
    doc.text(`Tanggal: ${startDate} - ${endDate}`, pdfWidth / 2, 24, { align: "center" });
    doc.addImage(imgData, "PNG", 10, 30, pdfWidth - 20, pdfHeight);
    doc.save(filename);
  };

  const lineData = {
    labels: chartData.map(item => item.day),
    datasets: [
      {
        label: "Minggu Ini",
        data: chartData.map(item => item.this_week),
        borderColor: "green",
        backgroundColor: "green",
      },
      {
        label: "Minggu Lalu",
        data: chartData.map(item => item.last_week),
        borderColor: "red",
        backgroundColor: "red",
      },
    ],
  };
// Data untuk view halaman aktif
// const paginatedMonthlyTransactions = monthlyTransactions.slice(
//   (monthlyPage - 1) * 10,
//   monthlyPage * 10
// );

const salesPerDayBarData = {
  labels: salesPerDay.map((item) => item.fullname),
  datasets: [
    {
      label: "Total Penjualan",
      data: salesPerDay.map((item) => item.total_amount),
      backgroundColor: "rgba(0, 123, 255, 0.6)", // Biru transparan
      borderColor: "rgba(0, 123, 255, 1)",       // Outline batang
      borderWidth: 1,
      barThickness: 30, // Opsional: kontrol lebar batang
    },
  ],
};
const barOptions = {
  responsive: true,
  plugins: {
    legend: { position: "top" },
    title: { display: false },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        callback: (value) => `Rp ${value.toLocaleString("id-ID")}`,
      },
    },
  },
};
const fetchSalesPerDay = async (filter) => {
  try {
    if (!filter.outlet_id || !filter.start_date || !filter.end_date) return;

    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/report/sales-report-per-day`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: {
        outlet_id: Number(filter.outlet_id),
        start_date: filter.start_date,
        end_date: filter.end_date,
        },
      }
    );
    setSalesPerDay(res.data.data);
  } catch (err) {
    console.error("Failed to fetch sales per day", err);
  }
};
useEffect(() => {
  const role = localStorage.getItem("role");

  if (role !== "manager") {
    if (tempFilters.outlet) {
      fetchCashiers(tempFilters.outlet);
    } else {
      setCashiers([]); // kosongkan jika outlet belum dipilih
    }
  } else {
    fetchCashiers(); // manager, otomatis ambil dari localStorage
  }
}, [tempFilters.outlet]);


const fetchMonthlyTransactions = async () => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/report/sales-report-per-month`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        outlet_id: monthlyFilters.outlet_id,
        page: monthlyPage,
        search: monthlyFilters.search,
        per_page: 10,
        order: monthlyFilters.order_by,
        sort: monthlyFilters.sort
      }

    });

    setMonthlyTransactions(res.data.data);
    setMonthlyMeta(res.data.meta);
  } catch (err) {
    console.error("Failed to fetch monthly transactions", err);
  }
};
useEffect(() => {
  if (monthlyFilters.outlet_id) {
    fetchMonthlyTransactions();
  }
}, [monthlyFilters, monthlyPage]);
const fetchSalesPerCashier = async (cashierId, date) => {
  if (!cashierId || !date) {
    setSalesPerCashier([]); // Kosongkan grafik jika input tidak lengkap
    return;
  }
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/report/sales-report-per-cashier/${cashierId}?date=${date}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    setSalesPerCashier(res.data.data);
  } catch (err) {
    console.error("Failed to fetch sales per cashier", err);
  }
};
useEffect(() => {
  if (role === "manager" && idOutletManager) {
    setTempFilters((prev) => ({ ...prev, outlet: idOutletManager }));
    setFilters((prev) => ({ ...prev, outlet: idOutletManager }));
  }
}, [role, idOutletManager]);
useEffect(() => {
  const role = localStorage.getItem("role");
  const outletId = localStorage.getItem("id_outlet");

  if (role === "manager" && outletId) {
    setMonthlyFilters(prev => ({ ...prev, outlet_id: outletId }));
  }
}, []);
useEffect(() => {
  const role = localStorage.getItem("role");
  const outletId = localStorage.getItem("id_outlet");

  if (role === "manager" && outletId) {
    setChartFilter((prev) => ({ ...prev, outlet_id: outletId }));
  }
}, []);
useEffect(() => {
  if (printMode === "grafik" || printMode === "transaksi" || printMode === "perjam") {
    const timeout = setTimeout(() => {
      window.print();
      setPrintMode(null); // reset setelah print
    }, 600);
    return () => clearTimeout(timeout);
  }
}, [printMode]);

 return (
  <div className="p-6 bg-white to-green-50 min-h-screen rounded-2xl">
    {/* Breadcrumb */}
                <nav className="text-gray-500 text-sm mb-3">
                  <ol className="flex items-center gap-2">
                    <li className="hover:text-gray-700 transition">Detailed Report</li>
                    <li>/</li>
                      <li className="text-gray-700 font-medium">Sales Report</li>
                  </ol>
                </nav>
          {/* Title */}
          <h2 className="text-3xl font-bold text-gray-800 mb-4 tracking-tight flex items-center gap-2">
                  <span className="text-green-600 text-3xl"> 
                    <div className="p-3 bg-green-100 rounded-2xl shadow-inner">
                    <BsGraphUpArrow className="text-green-600" />
                    </div>
                    </span> Sales Report
                    
                </h2>
                <p className="text-gray-600">Laporan Transaksi yang sudah di lakukan</p>
                <hr></hr>

    {/* EXPORT BUTTON */}
    <div className="flex justify-end mb-4">
      <button
        onClick={exportChartAndDataToExcel}
        className="mt-4 bg-yellow-500 text-white px-6 py-3 rounded-full shadow-lg hover:bg-yellow-600 transition transform active:scale-95 flex items-center gap-2"
      >
        <FaFileExcel /> Export Grafik + Data ke Excel
      </button>
    </div>

    {/* PANEL FILTER */}
    <div className="bg-white p-6 rounded-2xl shadow-xl space-y-6">

      {/* BARIS ATAS: Start/End Date + Nama Item */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="flex items-center gap-2">
          <FaCalendarAlt className="text-gray-500" />
          <input
            type="date"
            name="start_date"
            value={tempFilters.start_date}
            onChange={handleFilterChange}
            className="h-12 w-full border px-4 rounded-full shadow-md"
          />
        </div>
        <div className="flex items-center gap-2">
          <FaCalendarAlt className="text-gray-500" />
          <input
            type="date"
            name="end_date"
            value={tempFilters.end_date}
            onChange={handleFilterChange}
            className="h-12 w-full border px-4 rounded-full shadow-md"
          />
        </div>
        <div className="flex items-center gap-2">
          <FaSearch className="text-gray-500" />
          <input
            type="text"
            name="name"
            placeholder="Nama Item"
            value={tempFilters.name}
            onChange={handleFilterChange}
            className="h-12 w-full border px-4 rounded-full shadow-md"
          />
        </div>
      </div>

      {/* BARIS BAWAH: Outlet, Cashier, Terapkan */}
      <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
        <div className="flex gap-4 w-full md:w-auto flex-1">
          <div className="flex items-center gap-2 w-full">
            <FaStore className="text-gray-500" />
            <select
              name="outlet"
              value={tempFilters.outlet}
              onChange={handleFilterChange}
              className="h-12 w-full border px-4 rounded-full shadow-md"
              disabled={role === "manager"}
            >
              <option value="">Pilih Outlet</option>
              {outlets.map(outlet => (
                <option key={outlet.value} value={outlet.value}>
                  {outlet.label}
                </option>
              ))}
            </select>
          </div>
          <div className="flex items-center gap-2 w-full">
            <FaUser className="text-gray-500" />
            <select
              name="cashier"
              value={tempFilters.cashier}
              onChange={handleFilterChange}
              className="h-12 w-full border px-4 rounded-full shadow-md"
            >
              <option value="">Pilih Cashier</option>
              {cashiers.map(cashier => (
                <option key={cashier.value} value={cashier.value}>
                  {cashier.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <button
          onClick={handleApplyFilter}
          className="h-12 flex items-center gap-2 bg-blue-600 text-white px-6 rounded-full shadow-lg hover:bg-blue-700 transition transform active:scale-95"
        >
          ✓ Terapkan
        </button>
      </div>
    </div>
<br></br>
    {/* SUMMARY PANEL */}
    {summary && (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-blue-50 p-6 rounded-2xl shadow-xl text-center">
          <p className="text-sm text-blue-600 font-semibold">Total Penjualan</p>
          <p className="text-2xl font-bold text-blue-800">Rp {summary.total_sales.toLocaleString()}</p>
        </div>
        <div className="bg-green-50 p-6 rounded-2xl shadow-xl text-center">
          <p className="text-sm text-green-600 font-semibold">Transaction Amount</p>
          <p className="text-2xl font-bold text-green-800">{summary.transaction_amount}</p>
        </div>
        <div className="bg-yellow-50 p-6 rounded-2xl shadow-xl text-center">
          <p className="text-sm text-yellow-600 font-semibold">Item Sales</p>
          <p className="text-2xl font-bold text-yellow-800">{summary.item_sales}</p>
        </div>
      </div>
    )}

    {/* CHART & TABLES */}
    <div className="space-y-6">

      {/* GRAFIK MINGGUAN */}
      <div className="bg-white p-6 rounded-2xl shadow-xl">
        <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">📊 Statistik Pendapatan Mingguan</h2>
        {chartData.length > 0 ? (
          <Line id="weeklyChart" data={lineData} />
        ) : (
          <p className="text-gray-500">Tidak ada data untuk grafik mingguan.</p>
        )}
      </div>

      {/* TABEL TRANSAKSI BULANAN */}
      <div className="bg-white p-6 rounded-2xl shadow-xl">
        <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">🧾 Tabel Transaksi Bulanan</h2>
        <div className="overflow-x-auto rounded-2xl">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <input
              type="text"
              placeholder="Cari kode transaksi..."
              value={monthlyFilters.search}
              onChange={(e) => setMonthlyFilters(prev => ({ ...prev, search: e.target.value }))}
              className="border px-4 py-2 rounded-full shadow-md"
            />
            <select
              value={monthlyFilters.outlet_id}
              onChange={(e) => {
                if (role !== "manager") {
                  setMonthlyFilters(prev => ({ ...prev, outlet_id: e.target.value }));
                }
              }}
              className="border px-4 py-2 rounded-full shadow-md"
              disabled={role === "manager"}
            >
              <option value="">Pilih Outlet</option>
              {role === "manager"
                ? outlets.filter(o => o.value === localStorage.getItem("id_outlet")).map(o => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))
                : outlets.map(o => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
            </select>
            <button
              onClick={exportTransactionsToExcel}
              className="bg-yellow-500 text-white rounded-full px-6 py-2 hover:bg-yellow-600 shadow-lg transition transform active:scale-95 flex items-center gap-2"
            >
              <FaFileExcel /> Export Transaksi ke Excel
            </button>
          </div>

          {/* TABLE */}
          <div ref={printRef} className={`${printMode === "transaksi" ? "print-area" : ""}`}>
            <h2 className="text-lg font-semibold mb-2">🧾 Data Transaksi Bulanan</h2>
            <p className="mb-2 text-gray-700">
              Outlet: {monthlyFilters.outlet_id ? outlets.find(o => o.value === monthlyFilters.outlet_id)?.label || "-" : "Semua"}
            </p>
            <table className="w-full text-left border border-gray-300 text-sm rounded-2xl overflow-hidden">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="p-2 border">Tanggal</th>
                  <th className="p-2 border">Kode</th>
                  <th className="p-2 border">Status</th>
                  <th className="p-2 border">Jenis</th>
                  <th className="p-2 border text-right">Jumlah</th>
                </tr>
              </thead>
              <tbody>
                {monthlyTransactions.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50 transition">
                    <td className="border p-2">{new Date(item.date).toLocaleDateString("id-ID")}</td>
                    <td className="border p-2">{item.code}</td>
                    <td className="border p-2">{item.status}</td>
                    <td className="border p-2">{item.type}</td>
                    <td className="border p-2 text-right">Rp {item.amount?.toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* PAGINATION */}
          {monthlyMeta && (
            <div className="flex justify-between items-center mt-4 text-sm">
              <p>Halaman {monthlyMeta.current_page} dari {monthlyMeta.last_page}</p>
              <div className="flex gap-2">
                <button
                  disabled={monthlyPage === 1}
                  onClick={() => setMonthlyPage(prev => Math.max(1, prev - 1))}
                  className="px-3 py-1 bg-gray-200 hover:bg-gray-300 rounded-full disabled:opacity-50 transition"
                >
                  Prev
                </button>
                <button
                  disabled={monthlyPage === monthlyMeta.last_page}
                  onClick={() => setMonthlyPage(prev => Math.min(monthlyMeta.last_page, prev + 1))}
                  className="px-3 py-1 bg-gray-200 hover:bg-gray-300 rounded-full disabled:opacity-50 transition"
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* GRAFIK TOTAL PENJUALAN HARIAN */}
      <div className="bg-white p-6 rounded-2xl shadow-xl space-y-4">
        <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">📈 Grafik Total Penjualan per Hari</h2>

        {/* FILTER + EXPORT */}
        <div className="flex flex-wrap md:flex-nowrap gap-4 mb-4 items-end">
          {/* PILIH OUTLET */}
          <div className="flex flex-col basis-1/4">
            <label className="text-sm font-medium mb-1">Outlet</label>
            <select
              value={chartFilter.outlet_id}
              onChange={(e) => {
                if (role !== "manager") setChartFilter(prev => ({ ...prev, outlet_id: e.target.value }));
              }}
              className="border px-3 py-2 rounded-full shadow-md w-full"
              disabled={role === "manager"}
            >
              <option value="">Pilih Outlet</option>
              {role === "manager"
                ? outlets.filter(o => o.value === localStorage.getItem("id_outlet")).map(o => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))
                : outlets.map(o => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
            </select>
          </div>

          {/* TANGGAL TRANSAKSI */}
  <div className="flex flex-col basis-1/5 flex-shrink-0 relative">
    <label className="block text-sm font-medium mb-1">Tanggal Transaksi</label>
    <button
      onClick={() => setIsDatePickerOpen(true)}
      className="border px-4 py-2 rounded-full shadow text-left bg-white w-full whitespace-nowrap"
    >
      {startDate && endDate
        ? `${format(startDate, "yyyy-MM-dd")} ${customStartTime} → ${format(endDate, "yyyy-MM-dd")} ${customEndTime}`
        : startDate
        ? `${format(startDate, "yyyy-MM-dd")} ${customStartTime} → ${format(startDate, "yyyy-MM-dd")} ${customEndTime}`
        : "Pilih Tanggal"}
    </button>
    {isDatePickerOpen && (
      <div className="absolute z-50 mt-2 shadow-lg border rounded bg-white">
        <DatePicker
          selectsRange
          startDate={startDate}
          endDate={endDate}
          onSelect={(date) => {
            if (selectedShift !== "custom") {
              const shift = shiftOptions.find((s) => String(s.id) === selectedShift);
              if (shift) {
                setCustomStartTime(shift.start_time);
                setCustomEndTime(shift.end_time);
              }
              setDateRange([date, date]);
            }
          }}
          onChange={(update) => {
            if (selectedShift === "custom") {
              const [start, end] = update;
              setDateRange([start, end]);
            }
          }}
          inline
        >
          {/* SHIFT + JAM + TERAPKAN */}
          <div className="flex flex-col p-2 space-y-2">
            <div className="flex flex-col gap-1">
              {shiftOptions.map((shift) => (
                <button
                  key={shift.id}
                  onClick={() => {
                    setSelectedShift(shift.id.toString());
                    setDateRange([null, null]);
                    setCustomStartTime(shift.start_time);
                    setCustomEndTime(shift.end_time);
                  }}
                  className={`text-left px-3 py-1 rounded hover:bg-gray-100 ${
                    selectedShift === String(shift.id) ? "bg-gray-200 font-semibold" : ""
                  }`}
                >
                  {shift.name} ({shift.start_time} - {shift.end_time})
                </button>
              ))}

              {/* Custom */}
              <button
                onClick={() => {
                  setSelectedShift("custom");
                  setDateRange([null, null]);
                  setCustomStartTime("08:00:00");
                  setCustomEndTime("18:00:00");
                }}
                className={`text-left px-3 py-1 rounded hover:bg-gray-100 ${
                  selectedShift === "custom" ? "bg-gray-200 font-semibold" : ""
                }`}
              >
                Custom
              </button>
            </div>

            {/* Time Input */}
            {selectedShift === "custom" && (
              <div className="flex gap-2">
                <input
                  type="time"
                  value={customStartTime}
                  onChange={(e) => setCustomStartTime(e.target.value)}
                  className="border px-3 py-1 rounded w-full"
                />
                <input
                  type="time"
                  value={customEndTime}
                  onChange={(e) => setCustomEndTime(e.target.value)}
                  className="border px-3 py-1 rounded w-full"
                />
              </div>
            )}

            {/* TERAPKAN BUTTON */}
            <button
              onClick={() => {
                if (!startDate) {
                  alert("Pilih tanggal terlebih dahulu");
                  return;
                }

                if (selectedShift === "custom" && !endDate) {
                  alert("Pilih rentang tanggal lengkap");
                  return;
                }

                const fromDate = format(startDate, "yyyy-MM-dd");
                const fromTime = customStartTime;
                const toDate = format(
                  selectedShift === "custom" ? endDate : startDate,
                  "yyyy-MM-dd"
                );
                const toTime = customEndTime;

                const from = `${fromDate}T${fromTime}`;
                const to = `${toDate}T${toTime}`;

                const updatedChartFilter = {
                  outlet_id: chartFilter.outlet_id,
                  start_date: from,
                  end_date: to,
                };

                setChartFilter(updatedChartFilter);
                fetchSalesPerDay(updatedChartFilter);

                setIsDatePickerOpen(false);
              }}
              className="bg-blue-600 text-white px-3 py-2 rounded hover:bg-blue-700"
            >
              Terapkan
            </button>
          </div>
        </DatePicker>
      </div>
    )}
          </div>

          {/* EXPORT */}
          <div className="flex flex-col basis-1/4">
            <label className="block text-sm font-medium mb-1 text-white">.</label>
            <button
              onClick={exportSalesPerDayToExcel}
              className="bg-yellow-500 text-white rounded-full px-6 py-2 hover:bg-yellow-600 shadow-lg flex items-center gap-2 transition transform active:scale-95"
            >
              <FaFileExcel /> Export Grafik Kasir ke Excel
            </button>
          </div>
        </div>

        {/* GRAFIK */}
        <div ref={printRef} className={`p-6 text-sm leading-relaxed ${printMode === "grafik" ? "print-area" : ""}`}>
          {salesPerDay.length > 0 ? (
            <div id="salesPerDayChart" className="mb-8">
              <h3 className="text-lg font-bold mb-2">Grafik Total Penjualan per Hari</h3>
              <Bar data={salesPerDayBarData} options={barOptions} />
            </div>
          ) : (
            <p className="text-gray-500">Tidak ada data untuk grafik ini.</p>
          )}

          {/* PRINT TABLE */}
          <div className="hidden print:block mt-6">
            <h3 className="text-lg font-bold mb-1">Data Penjualan per Hari</h3>
            <div className="mb-4">
              <p><strong>Outlet:</strong> {chartFilter.outlet_id ? outlets.find(o => o.value === chartFilter.outlet_id)?.label || "Tidak ditemukan" : "Semua"}</p>
              <p><strong>Periode:</strong> {chartFilter.start_date && chartFilter.end_date ? `${new Date(chartFilter.start_date).toLocaleDateString("id-ID")} - ${new Date(chartFilter.end_date).toLocaleDateString("id-ID")}` : "Semua Waktu"}</p>
            </div>
            <table className="w-full text-left border border-gray-300 text-sm rounded-2xl overflow-hidden">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="border p-2 w-12">No</th>
                  <th className="border p-2">Nama Kasir</th>
                  <th className="border p-2 text-right">Total Penjualan</th>
                </tr>
              </thead>
              <tbody>
                {salesPerDay.map((item, idx) => (
                  <tr key={item.id} className="hover:bg-gray-50">
                    <td className="border p-2">{idx + 1}</td>
                    <td className="border p-2">{item.fullname}</td>
                    <td className="border p-2 text-right">Rp {item.total_amount.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* GRAFIK PER JAM PER KASIR */}
      <div className="bg-white p-6 rounded-2xl shadow-xl space-y-4">
        <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">📈 Grafik Penjualan per Jam (Per Kasir)</h2>

        <div className="flex flex-wrap md:flex-nowrap gap-4 mb-4 items-end">
          {/* PILIH OUTLET */}
          <div className="flex flex-col basis-1/4">
            <label className="text-sm font-medium mb-1">Pilih Outlet</label>
            <select
              value={tempFilters.outlet}
              disabled={role === "manager"}
              onChange={(e) => {
                const outletId = e.target.value;
                setTempFilters(prev => ({ ...prev, outlet: outletId }));
                setSelectedCashierId("");
                fetchCashiers(outletId);
              }}
              className="border px-3 py-2 rounded-full shadow-md"
            >
              <option value="">Pilih Outlet</option>
              {outlets.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
          </div>

          {/* PILIH KASIR */}
          <div className="flex flex-col basis-1/4">
            <label className="text-sm font-medium mb-1">Pilih Kasir</label>
            <select
              value={selectedCashierId}
              onChange={(e) => {
                const cashierId = e.target.value;
                setSelectedCashierId(cashierId);
                if (cashierId && selectedCashierDate) fetchSalesPerCashier(cashierId, selectedCashierDate);
              }}
              className="border px-3 py-2 rounded-full shadow-md"
            >
              <option value="">Pilih Kasir</option>
              {cashiers.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
          </div>

          {/* TANGGAL */}
          <div className="flex flex-col basis-1/4">
            <label className="text-sm font-medium mb-1">Tanggal</label>
            <input
              type="date"
              value={selectedCashierDate}
              onChange={(e) => {
                const date = e.target.value;
                setSelectedCashierDate(date);
                if (selectedCashierId && date) fetchSalesPerCashier(selectedCashierId, date);
              }}
              className="border px-3 py-2 rounded-full shadow-md"
            />
          </div>

          {/* EXPORT */}
          <div className="flex flex-col">
            <label className="text-sm font-medium mb-1 text-white">.</label>
            <button
              onClick={exportSalesPerCashierToExcel}
              className="bg-yellow-500 text-white rounded-full px-6 py-2 hover:bg-yellow-600 shadow-lg flex items-center gap-2 transition transform active:scale-95"
            >
              <FaFileExcel /> Export Penjualan per Jam ke Excel
            </button>
          </div>
        </div>

        {/* CHART */}
        {salesPerCashier.length > 0 ? (
          <>
            <Line
              data={{
                labels: salesPerCashier.map(item => item.hour),
                datasets: [
                  {
                    label: "Penjualan per Jam",
                    data: salesPerCashier.map(item => item.amount),
                    fill: false,
                    borderColor: "rgb(75, 192, 192)",
                    backgroundColor: "rgb(75, 192, 192)",
                    tension: 0.3,
                  },
                ],
              }}
              options={{
                responsive: true,
                plugins: { legend: { position: "top" }, title: { display: false } },
                scales: {
                  y: {
                    beginAtZero: true,
                    ticks: {
                      callback: (value) => `Rp ${value.toLocaleString("id-ID")}`,
                    },
                  },
                },
              }}
            />

            {/* PRINT TABLE */}
            <div className="hidden print:block mt-6">
              <h3 className="text-lg font-bold mb-1">Data Penjualan per Jam</h3>
              <table className="w-full text-left border border-gray-300 text-sm rounded-2xl overflow-hidden">
                <thead className="bg-gray-100 text-gray-700">
                  <tr>
                    <th className="border p-2 w-12">No</th>
                    <th className="border p-2">Jam</th>
                    <th className="border p-2 text-right">Jumlah Penjualan</th>
                  </tr>
                </thead>
                <tbody>
                  {salesPerCashier.map((item, idx) => (
                    <tr key={idx} className="hover:bg-gray-50">
                      <td className="border p-2">{idx + 1}</td>
                      <td className="border p-2">{item.hour}</td>
                      <td className="border p-2 text-right">Rp {item.amount.toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <p className="text-gray-500">Tidak ada data penjualan per jam untuk kasir ini.</p>
        )}
      </div>

    </div> {/* END CHART & TABLES */}

  </div>
);

};

export default SalesReport;